import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import PropTypes from 'prop-types';
import {Descriptions, Input, Menu, Select, Tooltip, Alert} from 'antd';
import {isEmpty} from '../../util/isEmpty';
import CustomDropdownRender from '../common/CustomDropdownRender';
import {sortArrObjStr} from '../../util/sortArrObjStr';
import {Button} from "react-bootstrap";
import "../../CSS/Grid.css"
import PopUp from "./PopUp.js";
import {Create_New_Factory, Update_Factory_select, Update_In_Existing_Factory} from "../../actions";

const {SubMenu} = Menu;
const {Option} = Select;

const PICKUP = 'pickup';
const DELIVERY = 'delivery';

// selected existing factory fields
const BUSINESS_NAME = 'name';
const EMAIL = 'email';
const POSTAL = 'postal';
const COUNTRY = 'Country';
const CITY = 'city';
const ADDRESS = 'address';
const PORT = 'port';

const CONTACT_NAME = 'contact_name';
const PHONE_NUMBER = 'phone_number';

const BUSINESS_TYPE = 'busines_type';
const locationType = [{key: 'warehouse', title: 'Warehouse'}, {
    key: 'businesswithliftgate',
    title: 'Business with Lift Gate'
}, {key: 'businesswithloadingdock', title: 'Business with Loading Dock'}, {
    key: 'residential',
    title: 'Residential'
}, {key: 'port', title: 'Port'},];

/**
 * @component
 * @category Form Page
 * @name ExistingFactoryDescForm
 * @description Existing factory description form on pickup/delivery section
 * <br> <br>
 * **Example**
 * ```js
 *   <ExistingFactoryDescForm isPickupMode={true} portsJSON={{}} myCountries={[]} selectedFactoryJson={{}} handleSelectExistingNewPort={()=>{}}/>
 * ```
 */
class ExistingFactoryDescForm extends Component {


    state = {
        first_render: false,
        Pickup_country: {},
        name: "",
        email: "",
        postal: "",
        city: "",
        address: "",
        contact_name: "",
        phone_number: "",
        busines_type: "",
        form_click: {
            MessageType: "", MessageDescription: "",
            name:"",
            email:"",
            port:""
        },
        popUpDisplay: false,
        saveClicked: false,
        Selected_country: {
            Country: "", Ports: [], Port: {},
        },
        final_details:{},
        regEmail: /^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([;.](([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/i
    }

    componentDidMount() {
        if (!this.state.first_render || this.props.state_change) {
            this.GroupObject(this.props.originPortJSON, this.props.myCountries, this.props.portsJSON);
            this.update_state_for_form(this.props.selectedFactoryJson);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.transaction_type !== this.props.transaction_type) {
            this.update_state_for_form(this.props.selectedFactoryJson);
        }

        if (!this.state.first_render || this.props.state_change) {
            this.GroupObject(this.props.originPortJSON, this.props.myCountries, this.props.portsJSON);
            this.update_state_for_form(this.props.selectedFactoryJson);
        }
    }

    OnclickSaveFactoryInfo = async (isPickupMode,new_factory) => {
        const form = {...this.state.form_click}
        this.setState({saveClicked: true})
        if (this.state.Selected_country.Port.id !== undefined &&
            this.state.email !== undefined &&
            this.state.email !== null &&
            this.state.email !== "" &&
            this.state.name !== undefined &&
            this.state.name !== "" &&
            this.state.regEmail.test(this.state.email) 
            ){
            this.setState({form_click: {name:"",email:"",port:""}})

            let updated_details = {
                "address": this.state.address,
                "business_type": this.state.busines_type,
                "city": this.state.city,
                "contact_name": this.state.contact_name,
                "country": this.state.Selected_country.Country,
                "email": this.state.email,
                "id": this.props.selectedFactoryJson.id,
                "name": this.state.name,
                "phone_number": this.state.phone_number,
                "postal": this.state.postal,
                "isExistingFactorySelected": true,
                "port": this.state.Selected_country.Port
            }

            if (isPickupMode) {
                if(new_factory){
                    await this.props.Create_New_Factory(updated_details,isPickupMode)
                    updated_details.id= this.props.store_new_id
                    this.setState({final_details:updated_details})
                    this.props.Update_Factory_select(updated_details, true)
                    //this.props.handleSelectExistingNewPort()

                }else{
                    this.props.Update_In_Existing_Factory(updated_details, true)
                    this.props.Update_Factory_select(updated_details, true)
                }

            } else {
                if(new_factory){
                    await this.props.Create_New_Factory(updated_details,isPickupMode)
                    updated_details.id= this.props.store_new_id
                    this.setState({final_details:updated_details})
                    this.props.Update_Factory_select(updated_details, false)
                    // this.props.handleSelectExistingNewPort()
                }else{
                    this.props.Update_In_Existing_Factory(updated_details, false)
                    this.props.Update_Factory_select(updated_details, false)
                }
            }
            form.MessageType = "success"
            form.MessageDescription = "Details have been saved successfully"
            this.setState({popUpDisplay: true})
            setTimeout(() => {
                this.setState({ popUpDisplay: false, saveClicked: false });
              }, 2000);
        }
        else
        {
            this.setState({popUpDisplay: false}) 
            form.MessageType = "Error"
            if (this.state.Selected_country.Port.id === undefined) {
                form.port = "Please enter Port Details"
            }else if(this.state.name===undefined || this.state.name==="" || this.state.name === null){
                form.name = "Please enter business name"
            }
            else if (this.state.email===undefined || this.state.email === null ||  this.state.email==="" || !this.state.regEmail.test(this.state.email)) {
                if (isPickupMode) {
                    form.email = "Please enter valid shipper Email"
                } else {
                    form.email = "Please enter valid Factory Email"
                }
            } else {
                form.MessageType = "error"
                form.MessageDescription = "Server Error,Error code-0013. Please provide this to Prime Freight"
                this.setState({popUpDisplay: true})
                setTimeout(() => {
                    this.setState({ popUpDisplay: false, saveClicked: false });
                  }, 2000);
            }
        }

        this.setState({form_click: form})
    }


    // onExistingFactorySelectChange = (id,event) => {
    //     let selected_company={
    //         "id":id,
    //         "name":event.key
    //     }

    //     const {
    //         isPickupMode,
    //         pickupExistingFactoryJson,
    //         deliveryExistingFactoryJson,
    //     } = this.props;

    //     //
    //     const existingFactoryJson = isPickupMode
    //         ? pickupExistingFactoryJson
    //         : deliveryExistingFactoryJson;



    //     const selectedFactoryJson = existingFactoryJson.filter((value,index)=>{
    //         if(value.id===selected_company.id){
    //             return value
    //         }
    //     })

    //         this.props.Update_Factory_select(selectedFactoryJson[0],isPickupMode)

    // };


    // handleSaveDetails = () => {
    //     if(Object.keys(this.state.final_details).length > 0){
    //         if(this.props.isPickupMode){
    //             this.props.Update_Factory_select(this.state.final_details, true)

    //         }else {
    //             this.props.Update_Factory_select(this.state.final_details, false)
    //         }

    //         let object={
    //             "key":this.state.final_details.name
    //         }
    //         this.onExistingFactorySelectChange(this.state.final_details.id,object)
    //         // this.props.onExistingFactorySelectChange(this.state.final_details.id,object)

    //     }
    // }



    /**
     * @description it updates selected existing factory data. [Read more]{@link module:form_action~updatePickupDeliverySelectedExistingFactory}
     * <br> <br>
     * **updateSelectedExistingFactoryjson(inputObj) -> {void}**
     * <br><br>
     * **Parameters:**
     * | Name          | Type          | Description  |
     * | :------------ |:------------- | :------------|
     * | inputObj      | Object        | data to be updated e.g. `{country: "Austria"}` |

     * Returns: Type: void
     */
    updateSelectedExistingFactoryjson = (eve) => {
        let property_name = Object.keys(eve)
        let JSON = eve[property_name]
        let property_final_name = property_name[0]
        const updatedObjectCountry = {...this.state.Selected_country};

        if (property_final_name === "Country") {
            let selected_ports = []
            updatedObjectCountry.Country = JSON
            updatedObjectCountry.Port = {}
            selected_ports = this.Set_State_for_Port_And_Country(JSON)
            updatedObjectCountry.Ports = selected_ports
            this.setState({
                Selected_country: updatedObjectCountry
            })
            this.setState({address: ""})
            this.setState({city: ""})
            this.setState({postal: ""})

        } else if (property_final_name === "port") {
            updatedObjectCountry.Port = JSON
            this.setState({
                Selected_country: updatedObjectCountry
            })
        } else {
            this.setState({[property_final_name]: JSON})
        }
        const {isPickupMode} = this.props;


    };

    update_state_for_form = (selectedFactoryJson) => {
        if (selectedFactoryJson !== undefined) {
            this.setState({city: selectedFactoryJson.city})
            this.setState({postal: selectedFactoryJson.postal})
            this.setState({name: selectedFactoryJson.name})
            this.setState({email: selectedFactoryJson.email})
            this.setState({address: selectedFactoryJson.address})
            this.setState({busines_type: selectedFactoryJson.business_type})
            this.setState({contact_name: selectedFactoryJson.contact_name});
            this.setState({phone_number: selectedFactoryJson.phone_number});
            if(!this.props.new_factory && !this.props.state_change && this.props.state_change !== undefined){
                this.setState({form_click:{MessageType : "success",MessageDescription : "Details have been saved successfully"}})
                this.setState({popUpDisplay:true})
                setTimeout(() => {
                    this.setState({ popUpDisplay: false, saveClicked: false });
                }, 2000);
            }else {
                this.setState({form_click: {}})
                this.setState({popUpDisplay:false, saveClicked: false})
            }
        }
    }


    Set_State_for_Port_And_Country = (myCountry) => {
        let selected_port = []
        Object.keys(this.state.Pickup_country).find((country, index) => {
            if (country === myCountry) {
                selected_port = this.state.Pickup_country[country]
            }
        })

        return selected_port
    }


    GroupObject = (originPortJSON, myCountries, portsJSON) => {
        this.setState({
            first_render: true
        })

        let country_with_ports = originPortJSON.reduce((groups, obj) => {
            const {Country} = obj;
            if (!groups[Country]) {
                groups[Country] = [];
            }
            groups[Country].push(obj);
            return groups;
        }, {})

        this.setState({
            Pickup_country: country_with_ports
        })

        const updatedObjectCountry = {...this.state.Selected_country};
        updatedObjectCountry.Country = myCountries
        updatedObjectCountry.Port = portsJSON
        let selected_object_ports = {}

        Object.keys(country_with_ports).find((country, index) => {
            if (country === myCountries) {
                selected_object_ports = country_with_ports[country]
            }
        })
        updatedObjectCountry.Ports = selected_object_ports

        this.setState({
            Selected_country: updatedObjectCountry
        })


    }

    render() {
        let {
            portsJSON,
            myCountries,
            selectedFactoryJson,
            handleSelectExistingNewPort,
            isPickupMode,
            originPortJSON,
            state_change,
            new_factory,
            final_view_after_submit
        } = this.props;

        portsJSON.Name = portsJSON.name



        //no. of items in a row depending upon screen size
        const descColumn = {xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1};
        return (<div className='bottom-view-form'>
                <Descriptions
                    style={{
                        marginTop: '15px',
                    }}
                    bordered={true}
                    size="small"
                    column={descColumn}>

                    <Descriptions.Item label="Country"
                    >
                        <Select
                            value={this.state.Selected_country.Country || undefined}
                            style={{
                                width: '100%',
                                // maxWidth: window.innerWidth >= 768 && '147px',
                                border: !this.state.Selected_country.Country && '1px solid red',
                                borderRadius: !this.state.Selected_country.Country && '4px',
                            }}
                            placeholder="Select country"
                            onChange={(value) => {
                                this.updateSelectedExistingFactoryjson({
                                    [COUNTRY]: value,
                                });
                            }}
                            dropdownRender={(menu) => (<div>
                                    {myCountries.length !== 0 ? (menu) : (<CustomDropdownRender showSpin={true}/>)}
                                </div>)}
                        >
                            {Object.keys(this.state.Pickup_country).map((country) => (
                                <Option key={country} value={country}>
                                    {country}
                                </Option>))}
                        </Select>
                    </Descriptions.Item>

                    {this.state.Selected_country.Ports.length > 0 ? (
                        <Descriptions.Item label={isPickupMode ? 'Port' : 'Destination city'}>
                        <div style={{textAlign:"left"}}>
                            <Select
                                value={this.state.Selected_country.Port.Name}
                                style={{
                                    width:'170px',
                                    // maxWidth: window.innerWidth >= 768 && '147px',
                                    borderRadius: isEmpty(this.state.Selected_country.Port) && '4px',
                                    border: isEmpty(this.state.Selected_country.Port) && '1px solid red',
                                }}
                                placeholder="Select port"
                                onChange={(value) => {
                                    this.updateSelectedExistingFactoryjson({
                                        [PORT]: value,
                                    });
                                }}
                                dropdownRender={(menu) => (<div>
                                        {this.state.Selected_country.Ports.length !== 0 ? (menu) : (
                                            <CustomDropdownRender text="select country first"/>)}
                                    </div>)}
                            >
                                {this.state.Selected_country.Ports.map((port) => (<Option
                                        key={port.id}
                                        value={port}
                                    >
                                        {port.Name}
                                    </Option>))}

                            </Select>
                            </div>
                            {!this.state.Selected_country.Port.Name ? <div className="error-msg">{this.state.form_click.port}</div> : ''} 
                        </Descriptions.Item>) : (<div>

                        </div>)}


                    <Descriptions.Item label="City"
                    >
                        <Input
                            placeholder="Enter city"
                            value={this.state.city}
                            onChange={(e) => this.updateSelectedExistingFactoryjson({[CITY]: e.target.value,})}
                            style={{border: !this.state.city && '1px solid red'}}/>
                    </Descriptions.Item>

                    <Descriptions.Item label="Postal">
                        <Input
                            placeholder="Enter postal"
                            value={this.state.postal}
                            onChange={(e) => this.updateSelectedExistingFactoryjson({
                                [POSTAL]: e.target.value,
                            })}
                            style={{border: !this.state.postal && '1px solid red'}}
                        />
                    </Descriptions.Item>

                    {this.props.new_factory ? (<>
                            <Descriptions.Item label="Business Name">
                                <Input
                                    placeholder="Enter Business Name"
                                    value={this.state.name}
                                    onChange={(e) => this.updateSelectedExistingFactoryjson({
                                        [BUSINESS_NAME]: e.target.value,
                                    })}
                                    style={{border: !this.state.name && '1px solid red'}}
                                />
                               {!this.state.name ? <div className="error-msg">{this.state.form_click.name}</div> : ''} 
                            </Descriptions.Item>
                        </>) : (<Descriptions.Item label="Business Name">
                            {this.state.name}
                        </Descriptions.Item>)}


                    <Descriptions.Item label="Business Type">
                    <div style={{textAlign:"left"}}>
                        <Select
                            value={this.state.busines_type || undefined}
                            style={{
                                width: '170px',
                                // maxWidth: window.innerWidth >= 768 && '147px',
                                border: !this.state.busines_type && '1px solid red',
                                borderRadius: !this.state.busines_type && '4px',
                            }}
                            placeholder="Select a business type"
                            onChange={(value) => {
                                // console.log('select loc type val:', value);
                                this.updateSelectedExistingFactoryjson({
                                    [BUSINESS_TYPE]: value,
                                });
                            }}
                        >
                            {Array.isArray(locationType) && sortArrObjStr(locationType, undefined, 'key').map((itemObj) => (
                                <Option key={itemObj.key} value={itemObj.key}>
                                    <Tooltip title={itemObj.title}>{itemObj.title}</Tooltip>
                                </Option>))}
                        </Select>
                    </div>
                    </Descriptions.Item>

                    <Descriptions.Item label="Email">
                        <Input
                            required={true}
                            placeholder="Enter email"
                            value={this.state.email}
                            onChange={(e) => this.updateSelectedExistingFactoryjson({
                                [EMAIL]: e.target.value,
                            })}
                            style={{
                                border: !(this.state.email || this.state.phone_number) && '1px solid red',
                            }}
                        />
                         { (!this.state.email || this.state.email==="" || !this.state.regEmail.test(this.state.email))  ? <div className="error-msg">{this.state.form_click.email}</div> : ''} 
                    </Descriptions.Item>

                    <Descriptions.Item label="Contact Name">
                        <Input
                            placeholder="Enter contact name"
                            value={this.state.contact_name}
                            onChange={(e) => this.updateSelectedExistingFactoryjson({
                                [CONTACT_NAME]: e.target.value,
                            })}
                            style={{
                                border: !this.state.contact_name && '1px solid red',
                            }}
                        />
                    </Descriptions.Item>

                    <Descriptions.Item label="Phone Number">
                        <Input
                            placeholder="Enter phone number"
                            value={this.state.phone_number}
                            type={"number"}
                            onChange={(e) => this.updateSelectedExistingFactoryjson({
                                [PHONE_NUMBER]: e.target.value,
                            })}
                            style={{
                                border: !(this.state.email || this.state.phone_number) && '1px solid red',
                            }}
                        />
                    </Descriptions.Item>

                    <Descriptions.Item label="Address">
                        <Input
                            placeholder="Enter address"
                            value={this.state.address}
                            onChange={(e) => this.updateSelectedExistingFactoryjson({
                                [ADDRESS]: e.target.value,
                            })}
                            style={{border: !this.state.address && '1px solid red'}}
                        />
                    </Descriptions.Item>
                </Descriptions>
                <br></br>
                <Tooltip title="It will save shipper information in database" placement="top">
                    {final_view_after_submit?(
                        <div className="button_save_parent_div"
                             style={{width:"100%"}}
                        >
                            <Button
                                className="button_save"
                                onClick={() => this.OnclickSaveFactoryInfo(isPickupMode, this.props.new_factory)}
                            >
                                Save
                            </Button>
                        </div>
                    ):(
                        <div className="button_save_parent_div">
                            <Button
                                className="button_save"
                                onClick={() => this.OnclickSaveFactoryInfo(isPickupMode, this.props.new_factory)}
                            >
                                Save
                            </Button>
                        </div>
                    )}
                </Tooltip>
                {
                    this.state.saveClicked && this.state.popUpDisplay ?
                   <Alert type={this.state.form_click.MessageType} message={this.state.form_click.MessageDescription} showIcon />
                    : ''
                }

            </div>);
    }
}

ExistingFactoryDescForm.propTypes = {
    /**
     * whether this component is used in pickup section
     */
    isPickupMode: PropTypes.bool, /**
     * origin port json or destination port json on search page
     */
    portsJSON: PropTypes.object, /**
     * list of countries
     */
    myCountries: PropTypes.array, /**
     * selected Existing Factory for pickup/delivery on factory mode
     */
    selectedFactoryJson: PropTypes.object, /**
     * function to handle selected port obj in a single existing factory json
     */
    handleSelectExistingNewPort: PropTypes.func,
};


const mapStateToProps = (state) => {
    return {
        originPortJSON: state.route.originPortJSON.Ports,
        pickupExistingFactoryJson: state.form.pickup.existingFactoryJson,
        deliveryExistingFactoryJson: state.form.delivery.existingFactoryJson,
        showFormValidation: state.form.showFormValidation,
        know_users_details:state.route.User_factor_and_shipper_Details,
        deliveryFactoryInfo: state.form.factoryInfo.delivery,
        pickupFactoryInfo: state.form.factoryInfo.pickup,
        // :state.form.Update_Factory_select,
        selectedPickupExistingFactoryJson:
        state.form.pickup.selectedExistingFactoryJson,
        selectedDeliveryExistingFactoryJson:
        state.form.delivery.selectedExistingFactoryJson,
        final_view_after_submit:state.form.final_view_after_submit,
        store_new_id:state.form.store_new_id,
        transaction_type: state.code_config.transactionType,
    }
}

export default connect(mapStateToProps, actions)(ExistingFactoryDescForm);
